import React, { createContext, useContext, useState } from 'react';

// Create a context with default value of height as 0
const TabBarHeightContext = createContext({
  tabBarHeight: 0,
  setTabBarHeight: (height: number) => {},
});

// Custom hook to access the tab bar height context
export const useTabBarHeight = () => {
  return useContext(TabBarHeightContext);
};

// Provider component to wrap your app
export const TabBarHeightProvider = ({ children }: { children: React.ReactNode }) => {
  const [tabBarHeight, setTabBarHeight] = useState(0);

  const setTabBar = (height: number) => {
    setTabBarHeight(height);
  };

  return (
    <TabBarHeightContext.Provider value={{ tabBarHeight, setTabBarHeight:setTabBar }}>
      {children}
    </TabBarHeightContext.Provider>
  );
};
